import { alpha } from '@mui/material/styles';
import { ratingClasses } from '@mui/material/Rating';
import { svgIconClasses } from '@mui/material/SvgIcon';
// ----------------------------------------------------------------------
export function rating(theme) {
    var _a, _b, _c, _d;
    return {
        MuiRating: {
            styleOverrides: {
                root: (_a = {},
                    _a["&.".concat(ratingClasses.disabled)] = {
                        opacity: 0.48
                    },
                    _a),
                iconEmpty: {
                    color: alpha(theme.palette.grey[500], 0.48)
                },
                sizeSmall: (_b = {},
                    _b["& .".concat(svgIconClasses.root)] = {
                        width: 20,
                        height: 20
                    },
                    _b),
                sizeMedium: (_c = {},
                    _c["& .".concat(svgIconClasses.root)] = {
                        width: 24,
                        height: 24
                    },
                    _c),
                sizeLarge: (_d = {},
                    _d["& .".concat(svgIconClasses.root)] = {
                        width: 28,
                        height: 28
                    },
                    _d)
            }
        }
    };
}
